import { AlertLevel } from '@/types';
import { ToastVariant } from '@usepepper/sprout-kit-ui';

/**
 * Maps the domain AlertLevel to the SKUI toast variant.
 */
export const mapAlertLevelToToastVariant = (
  level: AlertLevel,
): ToastVariant => {
  switch (level) {
    case AlertLevel.Positive:
      return 'success';
    case AlertLevel.Negative:
      return 'error';
    case AlertLevel.Warning:
      return 'warning';
    case AlertLevel.Info:
    default:
      return 'info';
  }
};
